import { render, staticRenderFns } from "./ville_list.vue?vue&type=template&id=e4b82a5e&"
import script from "./ville_list.vue?vue&type=script&lang=js&"
export * from "./ville_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports